/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommonBookingInfoViewRestrictionsInnerFromJSON, CommonBookingInfoViewRestrictionsInnerToJSON, } from './CommonBookingInfoViewRestrictionsInner';
import { CommonBookingInfoViewHeaderFromJSON, CommonBookingInfoViewHeaderToJSON, } from './CommonBookingInfoViewHeader';
import { CommonBookingInfoViewBasketFromJSON, CommonBookingInfoViewBasketToJSON, } from './CommonBookingInfoViewBasket';
/**
 * Check if a given object implements the CommonBookingInfoView interface.
 */
export function instanceOfCommonBookingInfoView(value) {
    return true;
}
export function CommonBookingInfoViewFromJSON(json) {
    return CommonBookingInfoViewFromJSONTyped(json, false);
}
export function CommonBookingInfoViewFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'basket': json['basket'] == null ? undefined : CommonBookingInfoViewBasketFromJSON(json['basket']),
        'header': json['header'] == null ? undefined : CommonBookingInfoViewHeaderFromJSON(json['header']),
        'restrictions': json['restrictions'] == null ? undefined : (json['restrictions'].map(CommonBookingInfoViewRestrictionsInnerFromJSON)),
    };
}
export function CommonBookingInfoViewToJSON(json) {
    return CommonBookingInfoViewToJSONTyped(json, false);
}
export function CommonBookingInfoViewToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'basket': CommonBookingInfoViewBasketToJSON(value['basket']),
        'header': CommonBookingInfoViewHeaderToJSON(value['header']),
        'restrictions': value['restrictions'] == null ? undefined : (value['restrictions'].map(CommonBookingInfoViewRestrictionsInnerToJSON)),
    };
}
